import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.filesUploadFilter(request.url)) {
      request = request.clone({
        setHeaders: { 'ngsw-bypass': 'true' },
      });
    }
    return next.handle(request);
  }

  private filesUploadFilter(uri: string): boolean {
    return uri.includes('FilesUpload');
  }
}
